import CbCallout from './src/callout.vue';

CbCallout.install = function(Vue) {
  Vue.component(CbCallout.name, CbCallout);
};

export default CbCallout;
